import { Component, ChangeDetectorRef } from '@angular/core';

//import { CustomerClass } from '../models/customer.class';
import { CustomerService } from "../services/customer";
import {Router,RouterOutlet} from '@angular/router';
import {RouterLink} from '@angular/router';
import { Customer } from '../interfaces/customer.interface';

@Component({
  selector: 'app-customer',
  imports: [RouterOutlet, RouterLink],
  templateUrl: './customer.html',
  styleUrl: './customer.css'
})
export class CustomerComponent {
  
  public customers: Customer[] = [];

  constructor( private customerService: CustomerService, private cdr: ChangeDetectorRef, private router: Router) {
    this.getCustomers();
  }

  public async getCustomers(): Promise<void> {
    /* this.customerService.getCustomers().subscribe(
      data => this.customers = data,
      error => console.error('Error fetching data:', error)
    ); */
    try {
    this.customers = await this.customerService.getCustomers();
    this.cdr.detectChanges();
    //this.customers = this.customerService.customers;
    } catch (error) {
      console.error('getcustomers',error);
    }
    
}

public async deleteCustomer( customer: Customer ): Promise<void> {
      const confirmation = window.confirm(`Are you sure you want to delete ${customer.customername}?`);
      if (!confirmation) {
       return;
      }
      try
        {
          await this.customerService.delete(customer.id);
           this.getCustomers();
           this.cdr.detectChanges();
           this.router.navigateByUrl('customer')

        } catch (error) {
          console.error('deletecustomer',error);
        }
 
 /*        .subscribe(( status ) => {
          
          if (this.selectedCustomer === customer) { 
              this.selectedCustomer = null; 
            }
            this.getCustomers();
        }) */
       //console.log('done deleteCustomer');
  }

  onEdit( customer:Customer ): void{
    this.customerService.selectedCustomer = customer;
    this.router.navigateByUrl('editcustomer')
  }

  onEditAddress( customer:Customer ): void{
    this.customerService.selectedCustomer = customer;
    this.router.navigateByUrl('customeraddress')
  }

}
